import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import MyRoute from '../hocs/PrivateRoute';
import SignIn from '../pages/SignIn';
import SignUp from '../pages/SignUp';
import Home from '../pages/Home';
import Profile from '../pages/Profile';
import TrainingRoutine from '../pages/TrainingRoutine';
import Workout from '../pages/Workout';
import TrainingRoutineDetails from '~/pages/TrainingRoutineDetails';
import PasswordRecovery from '~/pages/PasswordRecovery';
import Users from '~/pages/Users';
import PasswordReset from '~/pages/PasswordReset';

export default function Routes() {
  return (
    <Switch>
      <MyRoute path="/signin" component={SignIn} exact />
      <MyRoute path="/signup" component={SignUp} exact />
      <MyRoute path="/password-recovery" component={PasswordRecovery} exact />
      <MyRoute
        path="/reset-password/userId=:userId/token=:token"
        component={PasswordReset}
        exact
      />
      <MyRoute isPrivate path="/home" component={Home} exact />
      <MyRoute isPrivate path="/profile" component={Profile} exact />
      <MyRoute isPrivate path="/users" component={Users} exact />
      <MyRoute
        isPrivate
        path="/users/:userId/training-routines"
        component={TrainingRoutine}
        exact
      />
      <MyRoute
        isPrivate
        path="/users/:userId/training-routines/:trainingRoutineId"
        component={TrainingRoutineDetails}
        exact
      />
      <MyRoute
        isPrivate
        path="/users/:userId/training-routines/:trainingRoutineId/workout/:workoutId"
        component={Workout}
        exact
      />
      <MyRoute path="/" component={() => <Redirect to="/signin" />} />
    </Switch>
  );
}
